var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path957",
    d: "M0-682.665H17.5v17.5H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41934",
    "data-name": "Group 41934",
    transform: "translate(17106 -2535)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15802",
    "data-name": "Rectangle 15802",
    width: 20,
    height: 20,
    transform: "translate(-17106 2535)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g951",
    transform: "translate(-17104.75 2536.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g953"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g955",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g961",
    transform: "translate(1.968 0.518)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path963",
    d: "M-559.287-94.065l-2.175-2.175a1.027,1.027,0,0,0-1.45,0L-574-85.151l3.625,3.625,11.09-11.09A1.027,1.027,0,0,0-559.287-94.065Z",
    transform: "translate(574.001 96.54)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g965",
    transform: "translate(0.518 11.907)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path967",
    d: "M0-192.913l1.45-5.075,3.625,3.625Z",
    transform: "translate(0 197.989)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g969",
    transform: "translate(11.607 2.268)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path971",
    d: "M-137.8-137.8l-3.625-3.625",
    transform: "translate(141.421 141.421)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.fbcfdc754bda44f8f49e8e318c7a00b0.svg";
export { ForwardRef as ReactComponent };